export enum ModuleNoAccessVisibilityType {
  Invisible = 1,
  GreyedOut = 2,
}
